module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "part",
      "id": "pt01"
    }
  }, [_c('h1', {
    staticClass: "pn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxxxiv"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p1"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0005#rpt01"
    }
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('h1', {
    staticClass: "pt"
  }, [_vm._v("The Law")]), _vm._v(" "), _c('h1', {
    staticClass: "ps"
  }, [_vm._v("The Positivity of Abstraction")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Because of the adjective Hegel attaches to it, abstract law is generally considered to be secondary within the economy of objective spirit, just as (although for different reasons) morality is. If "), _c('i', [_vm._v("Sittlichkeit")]), _vm._v(" is the concrete milieu in which “freedom, as the "), _c('i', [_vm._v("substance")]), _vm._v(", exists no less as "), _c('i', [_vm._v("actuality")]), _vm._v(" and "), _c('i', [_vm._v("necessity")]), _vm._v(" than as "), _c('i', [_vm._v("subjective")]), _vm._v(" will,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0008#fn88",
      "id": "fn88r"
    }
  }, [_vm._v("1")]), _vm._v(" law and morality are "), _c('i', [_vm._v("abstract")]), _vm._v(", which in the Hegelian context means at the very least that they are not fully intelligible by themselves. For many commentators, antilegalism is a characteristic trait of Hegelianism, which thus finds itself far from the dominant opinion within postrevolutionary political philosophy, which saw rights as the inalienable condition of political freedom. Against this common interpretation, I would like to establish here that "), _c('i', [_vm._v("because of its very abstraction")]), _vm._v(", abstract law is judged positively by Hegel to the extent that it is indispensable for adequately thinking the concept of law in a way that accounts for social and political modernity and history as the history of the actualization and concretization of law. This is what I show, at a general level, in the first chapter, which seeks to explain the expansion that the concepts of law and right undergo in Hegel’s treatment. The second chapter shows that this expansion makes it possible to overcome the difficulties of modern theories of natural law by thinking of law as “between nature and history.”"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p2"
    }
  }), _vm._v(" The third chapter studies Hegel’s discussion of the concept of contract: far from being a necessary tool for understanding the nature of the "), _c('i', [_vm._v("political")]), _vm._v(" relationship, as in the dominant current of modern thought (culminating with Fichte), the contract is what makes it possible to connect abstract law and modern "), _c('i', [_vm._v("civil")]), _vm._v(", “bourgeois” society, which actualizes its principles by making it possible to think the juridical conditions of the social.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah"
  }, [_vm._v("Footnotes")]), _vm._v(" "), _c('div', {
    staticClass: "notes"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0008#fn88r",
      "id": "fn88"
    }
  }, [_vm._v("1")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 33, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 48 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 62; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 50).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c954f90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-kervegan-0008.vue
// module id = 75
// module chunks = 0